<form (submit)="submit(form)" [formGroup]="form">
	<h1 mat-dialog-title>{{'emailShippingLabelView.title' | translate}}</h1>
	<mat-dialog-content>
		<div fxLayout="column" fxLayoutAlign="start">
			<app-email-input-with-chips [label]="'emailShippingLabelView.emailLabel' | translate" [parentForm]="form"
										[placeholder]="'emailShippingLabelView.emailPlaceholder' | translate">
			</app-email-input-with-chips>
			<mat-form-field fxLayout="column" fxLayoutAlign="stretch">
				<mat-label>{{'emailShippingLabelView.shippingLabelLabel' | translate}}</mat-label>
				<mat-select [formControlName]="'selectedShippingLabel'">
					<mat-option *ngFor="let sl of shippingLabels"
								[value]="sl?.procedureId">{{sl.description}}</mat-option>
				</mat-select>
				<mat-error>
					{{'emailShippingLabelView.shippingLabelLabel' | translate}} is required
				</mat-error>
			</mat-form-field>
			<mat-form-field fxLayout="column" fxLayoutAlign="stretch">
				<mat-label>{{'emailShippingLabelView.subjectLabel' | translate}}</mat-label>
				<input [formControlName]="'subject'" matInput/>
				<mat-error>
					{{'emailShippingLabelView.subjectLabel' | translate}} is required
				</mat-error>
			</mat-form-field>
			<mat-form-field fxLayout="column" fxLayoutAlign="stretch">
				<mat-label>{{'emailShippingLabelView.messageLabel' | translate}}</mat-label>
				<textarea [formControlName]="'message'" mat-autosize matInput></textarea>
				<mat-error>
					{{'emailShippingLabelView.messageLabel' | translate}} is required
				</mat-error>
			</mat-form-field>
			<mat-form-field *ngIf="data?.showIncludePiecesCheckbox && selectedLabelIsDefault" [appearance]="'none'">
				<input matInput class="display-none">
				<mat-checkbox [color]="'primary'" [formControlName]="'includePieces'">Print individual piece labels
				</mat-checkbox>
			</mat-form-field>
		</div>
	</mat-dialog-content>
	<mat-dialog-actions fxLayout="row" fxLayoutAlign="end" fxLayoutGap="5px">
		<button [color]="'accent'" mat-dialog-close mat-raised-button type="button">
			{{'emailShippingLabelView.cancelButton' | translate}}
		</button>
		<button [color]="'primary'" mat-raised-button type="submit">
			{{'emailShippingLabelView.sendButton' | translate}}
		</button>
	</mat-dialog-actions>
</form>
